module.exports = __webpack_public_path__ + "icomoon.ttf?a1551905f48129d747b3ef25941eecb7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/icomoon/icomoon.ttf?-rdnm34
// module id = 919
// module chunks = 27